const { useSelector } = require('react-redux');

const useCurrentApplication = ({ id }) => {
    const detail = useSelector((state) => state.applicationDetail);
    const currentApplication = detail?.[id]?.applicationForm;

    if (!currentApplication) {
        console.error('no application is found');
    }

    return currentApplication;
};

export default useCurrentApplication;
